module.exports = __webpack_public_path__ + "img/1006.e469d692.jpg";